export default "__VITE_ASSET__Clc7J9Fc__"